import React, { useEffect, useRef, useState, useCallback } from "react";
import { Button, Modal, Toast } from "@themesberg/react-bootstrap";
import { AddBannerForm } from "./partials/AddBannerForm";
import { useCookies } from "react-cookie";
import { add, uploadBanner } from "../../../../../controller/api/banner";
import { imageHost } from "../../../../../helper/config";

export default (props) => {
  const [cookies] = useCookies(["lottmekong"]);

  const [progress, setProgress] = useState(0);

  const [error, setError] = useState(false);

  const [imageUrl, setImageUrl] = useState("");

  const [status, setStatus] = useState(0);

  const [index, setIndex] = useState("");

  const imageRef = useRef("");

  const onImageChange = (image) => {
    imageRef.current = image;
  };

  const validate = async (s) => {
    const filename = `banner${new Date().getTime()}`;
    try {
      const uploaded = await uploadBanner(
        cookies.lottmekong,
        imageRef.current,
        filename,
      );
      if (uploaded) {
        setStatus(s);
        setImageUrl(`${imageHost}/get_image?filename=${filename}`);
      } else {
        alert("Upload ảnh lỗi");
      }
    } catch (e) {
      alert("Upload ảnh lỗi (hết phiên đăng nhập?)");
    }
  };

  const onSubmit = useCallback(async () => {
    try {
      const parsedIndex = index === "" ? undefined : parseInt(index, 10);
      const resp = await add(cookies.lottmekong, imageUrl, status, parsedIndex);
      if (resp) {
        window.location.reload();
      } else {
        alert("Có lỗi xảy ra");
        return false;
      }
    } catch (e) {
      setError(true);
      alert("error");
    }
  }, [cookies.lottmekong, imageUrl, status, index]);

  useEffect(() => {
    if (imageUrl.length > 0 && status > 0) {
      onSubmit();
    }
  }, [imageUrl, onSubmit, status]);

  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          Thêm quảng cáo
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Toast
          className="d-inline-block m-1"
          onClose={() => setError(false)}
          show={error}
          delay={3000}
          autohide
          bg="danger"
          key={3}
        >
          <Toast.Header>
            <strong className="me-auto">Lỗi</strong>
            {/* <small>11 mins ago</small> */}
          </Toast.Header>
          <Toast.Body>Không thêm được</Toast.Body>
        </Toast>
        <AddBannerForm setImage={onImageChange} setIndex={setIndex} />
        <hr />
        <h6>Uploading done {progress}%</h6>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={props.onHide}>
          Close
        </Button>
        <Button variant="primary" onClick={() => validate(1)}>
          Thêm
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
